import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import styled from "styled-components";
import OtpInput from "react18-input-otp";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import { NotifyError } from "../../utils/ShowError";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import { generateUUID } from "../../../src/utils/utilityHelper";
import { OtpProtectedOperations } from "../../../src/utils/constants";

const InputContainer = styled.div<{ BackGround?: string }>`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: ${(props) => (props.BackGround ? props.BackGround : "#edf4f6")};
    border: 1px solid
      ${(props) => (props.BackGround ? props.BackGround : "#b6bfdc")};
    margin: 0 0.5rem;
  }
`;

interface Props extends BaseProps {
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;
  email: string;
  mobile: string;
  personID: string;
  redirectOnLogin: (personID: string) => void;
}

const MFA = ({ mobile, email, personID, onClose, redirectOnLogin }: Props) => {
  const [numbers, setNumbers] = useState("");
  const [screen, setScreen] = useState<number>(0);
  const [verifyloader, setverifyLoader] = useState(false);
  const [sendotploader, setsendotploader] = useState(false);
  const [otpDestination, setOtpDestination] = useState<number>(0);
  const [emailRadioChecked, setEmailRadioChecked] = useState(false);
  const [mobileRadioChecked, setMobileRadioChecked] = useState(false);
  const newDestinationValueRef = useRef<HTMLInputElement | null>(null);
  const transactionIdRef = useRef<string>(generateUUID());

  const handleChange = (otpConfirm: any) => {
    const regex = /^[0-9]+$/;

    if (otpConfirm.length < numbers.length) {
      setNumbers(otpConfirm);
    } else if (regex.test(otpConfirm)) {
      setNumbers(otpConfirm);
    }
  };

  const handleVerification = async () => {
    setverifyLoader(true);

    const verificationResponse = await User.verifyOTPAndLogin({
      errorId: "verifyOTPError",
      data: {
        user: {
          password: User.loginInfo.password,
          username: User.loginInfo.username,
          sessionData: User.loginInfo.sessionData,
        },
        otpData: {
          OTP: numbers,
          oneTimePasswordConfirm: numbers,
          transactionId: transactionIdRef.current,
        },
      },
    });

    if (verificationResponse?.message === "Success") {
      setverifyLoader(false);
      setNumbers("");
      console.log("hit");
      redirectOnLogin(personID);
    }
  };

  const handleMobileRadioButton = async (event: any) => {
    if (User.initialInfo.maskedMobileNumber) {
      setMobileRadioChecked(true);
      setOtpDestination(1);
    } else {
      NotifyError(
        General?.codeLabels["cm_mobilenumberreqerr"]?.label +
          " " +
          General?.codeLabels["cm_interr"]?.label
      );
    }
  };

  const handleEmailRadioButton = async (event: any) => {
     if (User.initialInfo.maskedEmail) {
      setEmailRadioChecked(true);
      setOtpDestination(2);
    } else {
      NotifyError(
        General?.codeLabels["cm_email_rqd"]?.label +
          " " +
          General?.codeLabels["cm_interr"]?.label
      );
    }
  };

  const handleSendOTP = async () => {
    setNumbers("");
    setsendotploader(true);
    const newVal = newDestinationValueRef.current?.value;
    if (otpDestination == 1) {
      await General.sendOTP({
        errorId: "sendOTPError",
        data: {
         
          premiseId: null,
          email: null,
          mobile: mobile,
          personID,
          transactionId: transactionIdRef.current,
          operation: OtpProtectedOperations.MFA,
          // useProvidedContactInfo: false,
        },
      });
      setScreen(1);
      setsendotploader(false);
    } else if (otpDestination === 2) {
      await General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId: null,
          email: newVal ? newVal : email,
          mobile: null,
          personID,
          transactionId: transactionIdRef.current,
          operation: OtpProtectedOperations.MFA,
          // useProvidedContactInfo: false,
        },
      });
      setScreen(1);
      setsendotploader(false);
    } else {
      const currentLan = localStorage.getItem("settingUplanguage");
      if (currentLan === "ar" || currentLan === "hi") {
        NotifyError(General?.codeLabels["cm_otpfailed"]?.label);
      } else {
        NotifyError("Please Select OTP Destination");
      }
      setsendotploader(false);
    }
  };

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <div
      style={{
        minWidth: "45%",
        overflow: "auto",
        margin: "auto",
        direction:
          General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
            ? "rtl"
            : "ltr",
      }}
    >
      <div
        style={{
          width: "100%",
          justifyContent: "space-between",
          padding: "1rem",
          background: contrast?.contrastColor
            ? contrast?.contrastColor
            : ColorAss,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            justifySelf: "flex-start",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {General?.codeLabels["cm_verify_identity_header"]?.label !== undefined
            ? General?.codeLabels["cm_verify_identity_header"]?.label
            : " Verify Your Identity"}
        </h1>
      </div>

      <TabContainer
        style={{
          padding: "0px 0px 12px 0px",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
          color: contrast?.contrastColor
            ? contrast?.contrastColor
            : General?.ColorAss,
        }}
      >
        {screen === 0 && (
          <>
            <Typography
              component="p"
              sx={{
                paddingTop: "12px",
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_where_otp"]?.label !== undefined
                ? General?.codeLabels["cm_where_otp"]?.label
                : "Where can we send the OTP"}
            </Typography>

            <p
              style={{
                width: "70%",
                textAlign: "center",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_identity_verification"]?.label !==
              undefined
                ? General?.codeLabels["cm_identity_verification"]?.label
                : "We need to verify your identity before allowing access."}
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "baseline", gap: "5px" }}
              >
                <input
                  type={"radio"}
                  name={"otpDest"}
                  checked={mobileRadioChecked}
                  onClick={handleMobileRadioButton}
                />
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_otp_mode_mobile"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_otp_mode_mobile"]?.label
                    : "registered mobile"}
                  <br /> {mobile}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: "5px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                }}
              >
                <input
                  type={"radio"}
                  name={"otpDest"}
                  checked={emailRadioChecked}
                  onClick={handleEmailRadioButton}
                />
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_otp_mode_email"]?.label !== undefined
                    ? General?.codeLabels["cm_otp_mode_email"]?.label
                    : "registered email"}{" "}
                  <br /> {email}
                </p>
              </div>
            </div>

            <ButtonsContainer
              style={{
                display: "flex",
                justifyContent: "center",
                width: "fit-content",
              }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "white",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  whiteSpace: "nowrap",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none",
                }}
                onClick={handleSendOTP}
              >
                {sendotploader ? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_send_otp"]?.label !== undefined ? (
                  General?.codeLabels["cm_send_otp"]?.label
                ) : (
                  "SEND OTP"
                )}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        )}

        {screen === 1 && (
          <>
            <Typography
              component="p"
              sx={{
                paddingTop: "12px",
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_otp_send"]?.label !== undefined
                ? General?.codeLabels["cm_otp_send"]?.label
                : "Please enter the one-time password"}
            </Typography>
            <p
              style={{
                width: "60%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_we_send"]?.label !== undefined
                ? General?.codeLabels["cm_we_send"]?.label
                : "We have sent the OTP on this"}{" "}
              {otpDestination === 1
                ? `mobile number ${mobile}`
                : `email ${email}`}
            </p>

            <InputContainer
              BackGround={
                contrast?.contrastColor ? contrast?.contrastColor : ""
              }
              style={{ justifyContent: "center", direction: "ltr" }}
            >
              <OtpInput
                value={numbers}
                onChange={handleChange}
                numInputs={6}
                isInputNum={true}
              />
            </InputContainer>

            <p
              style={{
                width: "70%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                marginTop: "0.5rem",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {otpDestination === 2
                ? General?.codeLabels["cm_em_otp2min"]?.label !== undefined
                  ? General?.codeLabels["cm_em_otp2min"]?.label
                  : "If you do not receive email OTP within 5 minutes"
                : General?.codeLabels["cm_mob_otp2min"]?.label !== undefined
                ? General?.codeLabels["cm_mob_otp2min"]?.label
                : "If you do not receive mobile OTP within 5 minutes"}{" "}
              &nbsp;
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  fontWeight: "700",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={handleSendOTP}
              >
                {General?.codeLabels["cm_mob_resendotp"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_resendotp"]?.label
                  : "Resend OTP"}{" "}
              </span>
            </p>
            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  borderColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={() => setScreen(0)}
              >
                {General?.codeLabels["cm_backbutton"]?.label !== undefined
                  ? General?.codeLabels["cm_backbutton"]?.label
                  : "BACK"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "white",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none",
                }}
                onClick={handleVerification}
              >
                {verifyloader ? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_verifybtn_verify"]?.label !==
                  undefined ? (
                  General?.codeLabels["cm_verifybtn_verify"]?.label
                ) : (
                  "VERIFY"
                )}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        )}
      </TabContainer>
    </div>
  );
};

export default observer(MFA);
